import { Helmet } from "react-helmet-async";
import { SITE_KEY } from "../siteConfig";

const SITE_NAME = "Clinique Internationale";

const SITE_LOCATIONS = {
  india: "India",
  navimumbai: "Navi Mumbai",
  pune: "Pune",
  bangalore: "Bangalore",
  shirdi: "Shirdi",
};


function generateKeywords(title, description) {
  const text = `${title || ""} ${description || ""}`;
  const normalizedText = text.toLowerCase();

  const locations = [
    { name: "Navi Mumbai", pattern: /navi[\s-]+mumbai/i },
    { name: "Mumbai", pattern: /\bmumbai\b/i },
    { name: "Pune", pattern: /\bpune\b/i },
    { name: "Bangalore", pattern: /\bbangalore\b|\bbengaluru\b/i },
    { name: "Shirdi", pattern: /\bshirdi\b/i },
    { name: "India", pattern: /\bindia\b/i },
  ];

  const detectedLocations = locations
    .filter((location) => location.pattern.test(location.name === "Mumbai" ? text.replace(/navi[\s-]+mumbai/gi, " ") : text))
    .map((location) => location.name);

  const fallbackLocation = SITE_LOCATIONS[SITE_KEY] || "India";
  const targetLocations = detectedLocations.length
    ? detectedLocations
    : [fallbackLocation];

  const topics = [
    { match: /beard/, terms: ["beard hair transplant", "beard restoration"] },
    { match: /eyebrow/, terms: ["eyebrow hair transplant", "eyebrow restoration"] },
    { match: /eyelash/, terms: ["eyelash hair transplant", "eyelash restoration"] },
    { match: /female hair|women.*hair/, terms: ["female hair transplant", "hair restoration for women"] },
    { match: /body hair/, terms: ["body hair transplant", "body hair restoration"] },
    { match: /hairline/, terms: ["hairline reconstruction", "hairline restoration"] },
    { match: /hair loss/, terms: ["hair loss treatment", "hair loss consultation"] },
    { match: /cost|price|pricing/, terms: ["hair transplant cost", "hair transplant price"] },
    { match: /sapphire/, terms: ["Sapphire FUE hair transplant"] },
    { match: /\bprp\b|platelet.rich/, terms: ["PRP hair treatment", "platelet-rich plasma therapy"] },
    { match: /\bfut\b|follicular unit transplant/, terms: ["FUT hair transplant", "follicular unit transplantation"] },
    { match: /\bfue\b|follicular unit extraction/, terms: ["FUE hair transplant", "follicular unit extraction"] },
    { match: /hair transplant|hair restoration|hair transplantation/, terms: ["hair transplant clinic", "hair restoration"] },
  ];

  const matchedTerms = [
    ...new Set(
      topics
        .filter((topic) => topic.match.test(normalizedText))
        .flatMap((topic) => topic.terms)
    ),
  ];

  return [
    ...new Set(
      matchedTerms.flatMap((term) =>
        targetLocations.map((location) => `${term} in ${location}`)
      )
    ),
  ].join(", ");
}


function SEO({ title, description, url, author, image, keywords }) {
  const finalKeywords = keywords || generateKeywords(title, description);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {finalKeywords && <meta name="keywords" content={finalKeywords} />}

      {author && <meta name="author" content={author} />}
      <meta name="robots" content="index, follow" />
      <meta name="application-name" content={SITE_NAME} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      <link rel="canonical" href={url} />
    </Helmet>
  );
}

export default SEO;
